import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError } from "../../utils/api.types";

import {
    IDocumentSettingResponse,
    IDocumentSettingFormInputs,
    IDocumentSettings,
    IDocumentSettingUpdatePayload,
    IDocumentSetting
} from "../../utils/documentSetting.types";

/**
 * Fetch DocumentSettings async thunk.
*/
export const fetchDocumentSettings = createAsyncThunk(
    'documentSetting/fetchDocumentSettings',
    async (accountId: string): Promise<IDocumentSettings> => {
        const response = await axios.get(`/api/v1/document-settings/${accountId}`);

        return response.data;
    }
);

export const selectedDocumentSettingID = createAction("documentSetting/selectedDocumentSettingID", (documentSettingId) => {
    return {
        type: 'documentSetting/selectedDocumentSettingID',
        payload: documentSettingId
    }
});

/**
 * Fetch DocumentSettings async thunk.
*/
export const fetchDocumentSettingById = createAsyncThunk(
    'documentSetting/fetchDocumentSettingById',
    async (id: string): Promise<IDocumentSetting> => {
        const response = await axios.get(`/api/v1/document-settings/single/${id}`);
        return response.data.documentSetting;
    }
);

/**
 * Add DocumentSetting async Thunk.
 */
export const addDocumentSetting = createAsyncThunk(
    'documentSetting/addDocumentSetting',
    async (documentSettingPayload: IDocumentSettingFormInputs): Promise<IDocumentSettingResponse> => {
        const response = await axios.post(`/api/v1/document-settings`, documentSettingPayload);

        return response.data
    }
);

/**
 * Update DocumentSetting async Thunk.
 */
export const updateDocumentSetting = createAsyncThunk<
    IDocumentSettingResponse,
    IDocumentSettingUpdatePayload,
    {
        rejectValue: IError,
    }
>(
    'documentSetting/updateDocumentSetting',
    async ({ id, documentSettingPayload }: IDocumentSettingUpdatePayload, thunkApi) => {
        try {
            const response = await axios.put(`/api/v1/document-settings/${id}`, documentSettingPayload);

            const { data } = response;

            if (response.status === 200) {
                return data;
            }

            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
    }
);

/**
 * Delete DocumentSetting async Thunk.
 */
export const deleteDocumentSetting = createAsyncThunk(
    'documentSetting/deleteDocumentSetting',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/document-settings/${id}`);

        response.data['id'] = id;

        return response.data
    }
);

